export const ServiceUrl = {
  SETTINGS: "v1/settings?type=website,socialmedia",
  COURSES: "v1/set/list-courses",
  DEPARTMENTS: "v1/set/list-dept",

  MENUS: "site/v1/menus/list-menus",
  LINKS: "site/v1/menus/list-link",
  GET_PAGE: "site/v1/page/get",
  GET_IMAGES: "site/v1/page/get-images",
  GET_YEAR: "site/v1/page/get-year",
  GET_EVENT: "site/v1/page/get-event",
  LIST_PAGES: "site/v1/page/list",
  TODAY_THIRUKURAL: "site/v1/public/thirukural",

  // Department pages
  DEPT: {
    SLIDERS: "site/v1/dept/sliders",
    PAGE: "site/v1/dept/page",
    COURSES: "site/v1/dept/courses",
    FILES: "site/v1/dept/files",
    FACULTY: "site/v1/dept/faculty",
    ESSTABLISHMENT: "site/v1/dept/esstablishment",
  },

  // Establishment in staff — list-only queries for V3Establishment tabs
  ESTABLISHMENT: {
    LIST_INCHARGE: "site/v1/dept/list-incharge",
    LIST_QUALIFICATION: "site/v1/dept/list-qualification",
    LIST_EXPERIENCE: "site/v1/dept/list-experience",
    LIST_EXAMINATION: "site/v1/dept/list-examination",
    LIST_DOCTORAL: "site/v1/dept/list-doctoral",
    LIST_PRESENT_POSITION: "site/v1/dept/list-present-position",
    LIST_RESEARCH_GUIDANCE: "site/v1/dept/list-research-guidance",
    LIST_RESEARCH_PROJECTS: "site/v1/dept/list-research-projects",
    LIST_AWARDS: "site/v1/dept/list-awards",
    LIST_PRESENTATION: "site/v1/dept/list-presentation",
    LIST_PUBLICATION: "site/v1/dept/list-publication",
    LIST_DEPT_EXAMINATION: "site/v1/dept/list-dept-examination",
    LIST_ACHIEVEMENT: "site/v1/dept/list-achievement",
    LIST_FACULTY_DEVELOPMENT: "site/v1/dept/list-faculty-development",
    LIST_TRAINING: "site/v1/dept/list-training",
    LIST_COUNTRY_VISIT: "site/v1/dept/list-country-visit",
    LIST_MEMO: "site/v1/dept/list-memo",
    LIST_SECTION_TRANSFER: "site/v1/dept/list-section-transfer",
  },

  // Subjects
  SUBJECTS: {
    LIST_COURSE_SUBJECTS: "site/v1/dept/list-by-course",
    LIST_OLD_QUESTION_PAPERS: "site/v1/dept/list-old-question-paper",
  },

  LIST_SLIDERS: "site/v1/page/sliders",
  RECENT_GALLERY: "site/v1/page/recent-gallery",
  LIST_GALLERY: "site/v1/page/gallery",

  HOME_PAGE_SETTINGS: "site/v1/page/home-page-settings",
  HOME_PAGE_count: "site/v1/page/home-page-count",

  LIST_EVENT_YEARS: "site/v1/page/get-year",
};
